var _defs, _line, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkinTypeSensitiveSkin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.07 176.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.clsSESK-1{fill:none;}\n.clsSESK-1,.clsSESK-2,.clsSESK-3{stroke:#a64daa;}\n.clsSESK-1,.clsSESK-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}\n.clsSESK-2,.clsSESK-3,.clsSESK-4{fill:#a64daa;}\n.clsSESK-2{stroke-miterlimit:10;}\n"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "clsSESK-1",
    x1: 4.5,
    y1: 80.17,
    x2: 186.75,
    y2: 80.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clsSESK-2",
    d: "M193.6,104.64c-.71,0-1.44-.07-2.21-.07-1,0-1.88,0-2.75.1-7.24.51-11.34,3-15,5.25s-6.49,4-12.7,4-9.08-1.75-12.7-4c-4.1-2.51-8.74-5.35-17.75-5.35s-13.65,2.84-17.75,5.35c-3.62,2.22-6.48,4-12.7,4s-9.07-1.75-12.7-4c-4.09-2.51-8.73-5.35-17.74-5.35s-13.66,2.84-17.75,5.35c-3.62,2.22-6.49,4-12.7,4s-9.08-1.75-12.7-4c-4.1-2.51-8.74-5.35-17.75-5.35-2.34,0-4.23,1.57-4.23,3.5s1.89,3.49,4.23,3.49c6.21,0,9.08,1.75,12.7,4,4.1,2.51,8.74,5.35,17.75,5.35S52.8,118,56.9,115.53c3.62-2.22,6.48-4,12.7-4s9.07,1.75,12.7,4C86.39,118,91,120.88,100,120.88s13.66-2.84,17.75-5.35c3.63-2.22,6.49-4,12.7-4s9.08,1.75,12.7,4c4.1,2.51,8.74,5.35,17.75,5.35s13.65-2.84,17.75-5.35c3-1.83,5.47-3.34,9.75-3.81a26.51,26.51,0,0,1,2.95-.16c.9,0,1.73,0,2.51.11a4.37,4.37,0,0,0-.3-7Z",
    transform: "translate(-3.97 -9.77)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-1",
    cx: 14.89,
    cy: 129.54,
    r: 10.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-3",
    cx: 35.41,
    cy: 156.61,
    r: 6.51
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-4",
    cx: 55.81,
    cy: 171.05,
    r: 5.41
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-4",
    cx: 95.63,
    cy: 171.05,
    r: 5.41
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-4",
    cx: 136.67,
    cy: 171.05,
    r: 5.41
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-3",
    cx: 75.91,
    cy: 156.61,
    r: 6.51
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-3",
    cx: 116.97,
    cy: 156.61,
    r: 6.51
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-3",
    cx: 157.47,
    cy: 156.61,
    r: 6.51
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-1",
    cx: 55.81,
    cy: 129.54,
    r: 10.26
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-1",
    cx: 96.5,
    cy: 129.54,
    r: 10.26
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-1",
    cx: 136.67,
    cy: 129.54,
    r: 10.26
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "clsSESK-1",
    cx: 177.38,
    cy: 129.54,
    r: 10.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clsSESK-1",
    d: "M107,65.32c-.81,0-11.81-1.12-11.77-2.42-.13,3.61,5.92,8.14,5.92,8.14-24.47-2.63-29-13.56-29-13.56.73,4,4.49,10.93,4.49,10.93C71.57,66.37,66.3,64.69,62,61,57.1,56.85,53.19,52,51.62,46.53a18,18,0,0,1-.69-4c.47.16,2.1-7.52,1.22-7.87a23.73,23.73,0,0,1,1.44-3.16C57.36,24.66,65.69,22,73,21.35a39,39,0,0,1,7.94-.12c1,.13,4.77.54,4.77.54-3.66,3.45-7.07,9.7-7.07,9.7,13.37-11.43,32.84.06,32.84.06a20.39,20.39,0,0,0-6.56,4.58c.51-.39,3.6,1.19,4.09,1.38,8.16,3.15,18.94,5.18,26.94.59,9.55-5.49,17.22-14.74,22.5-24.31a68.64,68.64,0,0,1-5.74,22.32C144.64,53.16,126.39,66.63,107,65.32Z",
    transform: "translate(-3.97 -9.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clsSESK-1",
    d: "M103.61,49.11s-12.4.34-42.18-7C39.91,36.72,29.94,29,29.94,29",
    transform: "translate(-3.97 -9.77)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinTypeSensitiveSkin);
export default __webpack_public_path__ + "static/media/skin-type-sensitive-skin.730d24f7.svg";
export { ForwardRef as ReactComponent };